/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { randomColorIndex } from 'solis/theme/palette';

import Logic from 'fierry/data/logic';


const ACCOUNT_NAMES = [ 'Zero', 'One', 'Two', 'Three', 'Four' ];


export default class AccountCass extends Logic
{
  constructor (account, galaxy)
  {
    super(account, galaxy);

    this.galaxy = galaxy;
  }


  initializeName ()
  {
    this.setName(this.makeAccountName());
  }


  initializeTheme ()
  {
    this.setTheme(randomColorIndex());
  }


  incrementColonyCounter ()
  {
    this.object.set({ colonyCounter: this.object.cass.colonyCounter + 1 });
  }


  setName (name)
  {
    this.object.set({ name });

    this.getScore().set({ name });
  }


  setTheme (theme)
  {
    this.object.set({ theme });

    this.getScore().set({ theme });
  }


  getScore ()
  {
    return this.galaxy.getScore(this.object.cass.id);
  }


  makeAccountName ()
  {
    return ACCOUNT_NAMES[this.galaxy.getAccounts().size() - 1];
  }


};
